import { isNullOrUndefined } from '@utils/object';

const ZERO = 0;
const MAX_PERCENT = 100;

export const MIN_DISCOUNT = 5;

export const isWeekly = product =>
  product.applyDiscount && Boolean(product.priceWithDiscount);

export const isSubsidizedProduct = product =>
  product?.subsidizedProduct &&
  product?.subsidizedProduct.originalPrice !== product?.price &&
  product?.subsidizedProduct.originalPrice !== ZERO;

export const getDiscountSubsidized = (price, originalPrice) => {
  const discount = Math.round(100 - (price * 100) / originalPrice);
  return discount <= MAX_PERCENT ? discount : null;
};

export const getDiscountPercent = (product, discountFromShop) => {
  if (!isNullOrUndefined(product.discount)) return product.discount;
  if (isSubsidizedProduct(product)) {
    return getDiscountSubsidized(
      product.price,
      product.subsidizedProduct.originalPrice,
    );
  }
  if (isWeekly(product)) {
    return discountFromShop;
  }
  return null;
};
